import { ARTIFACT_KINDS } from "./types"
import type { ArtifactKind } from "./types"

export const DEFAULT_ARTIFACT_TITLES_BY_KIND: Record<ArtifactKind, string> = {
  [ARTIFACT_KINDS.TABLE]: "AI Table",
  [ARTIFACT_KINDS.PLOT]: "AI Plot",
}
